import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Scan Alerts panel art: a header with a live dot, then match rows
 * (time, bold ticker, alert text, price), the newest tinted.
 */
export function AlertWindowsArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <rect x={14} y={12} width={52} height={10} rx={3} fill="hsl(var(--foreground) / 0.16)" />
      <circle cx={80} cy={17} r={3} fill="hsl(var(--chart-candle-up))" />
      <rect x={88} y={14} width={34} height={6} rx={3} fill="hsl(var(--foreground) / 0.12)" />
      <rect x={128} y={12} width={18} height={10} rx={3} fill="hsl(var(--primary) / 0.35)" />
      {[36, 52, 68, 84].map((y, i) => (
        <g key={y}>
          {i === 0 && (
            <rect
              x={10}
              y={y - 8}
              width={140}
              height={14}
              rx={3}
              fill="hsl(var(--primary) / 0.14)"
            />
          )}
          <rect
            x={14}
            y={y - 2}
            width={20}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.12)"
          />
          <rect x={40} y={y - 3} width={20} height={6} rx={2} fill="hsl(var(--foreground) / 0.3)" />
          <rect
            x={66}
            y={y - 2}
            width={i % 2 ? 36 : 48}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.12)"
          />
          <rect
            x={124}
            y={y - 2}
            width={22}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.2)"
          />
        </g>
      ))}
    </svg>
  )
}
